import axios from "axios";
import { useRefresh } from "../../../../utils/RefreshProvider";
import useConfirmation from "../../../../utils/useConfirmation";
import Notify from "../../../../utils/useNotify";
import { useTranslation } from "react-i18next";
import { TrashIcon } from "@heroicons/react/24/solid";

export default function DeleteElement({ typeProp, elementId, customerP }) {
  const { t } = useTranslation();
  const { open, ConfirmComponent } = useConfirmation();
  const { triggerRefresh } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const link = typeProp === "size" ? 'admin/sizes/' : typeProp === "category" ? 'admin/categories/'
    : typeProp === "product" ? 'admin/product/' : typeProp === "customer" ? 'admin/customer/'
      : typeProp === "slide" ? 'admin/carousel/' : typeProp === "color" ? 'admin/colors/': 'admin/stock/';

  const handleConf = () => {
    open(
      {
        title: t("delete-confirmation-header"),
        text: t("delete-confirmation-body"),
        action: "add",
      },
      handleDelete
    );
  };

  const handleDelete = async () => {
    await axios.delete(localhost + link + elementId, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        triggerRefresh();
        Notify('success', t("delete-" + typeProp + "-success"));
      }).catch((err) => {
        Notify('error', t("delete-" + typeProp + "-error"));
      });
  }

  return (
    <>
      {ConfirmComponent}
      {
        customerP ? (
          <button type="button" onClick={handleConf} className='px-3 py-1.5 bg-red-600 text-white hover:bg-red-700 text-sm rounded-md'>
            {t("delete")}
          </button>
        ) : (
          <button type="button" onClick={handleConf} className="text-red-600 hover:bg-red-600/10 transition-colors duration-150 rounded-md p-1.5">
            <TrashIcon className="h-5 w-5" />
          </button>
        )
      }
    </>
  )
}

// text-black transition-colors duration-150 hover:bg-black/10 rounded-md p-1.5